import React, { useState } from 'react';
import styles from './Header.module.css';
const Header = ({ currentPath = '/' }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const isActive = (path) => {
        if (path === '/') {
            return currentPath === '/';
        }
        if (path === '/blog') {
            return currentPath?.startsWith('/blog');
        }
        return currentPath === path;
    };
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };
    return (React.createElement("header", { className: styles.header },
        React.createElement("div", { className: styles.headerContent },
            React.createElement("a", { href: "/", className: styles.logo }, "Wolfeye Consulting"),
            React.createElement("button", { className: styles.mobileMenuButton, onClick: toggleMobileMenu, "aria-label": "Toggle menu" },
                React.createElement("span", { className: mobileMenuOpen ? styles.hamburgerOpen : styles.hamburger })),
            React.createElement("nav", { className: `${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}` },
                React.createElement("a", { href: "/", className: `${styles.mobileOnly} ${isActive('/') ? styles.active : ''}` }, "Home"),
                React.createElement("a", { href: "/about", className: isActive('/about') ? styles.active : '' }, "About"),
                React.createElement("a", { href: "/services", className: isActive('/services') ? styles.active : '' }, "Services"),
                React.createElement("a", { href: "/contact", className: isActive('/contact') ? styles.active : '' }, "Contact")))));
};
export default Header;
